// src/containers/reportBuilder/GraphicsTab.jsx
//
// Placeholder tab for organisation-level report graphics settings.
//
// Planned content (to be designed and built):
//   • Cover image picker  — selects from the org's Documents & Media section
//   • Organisation logo   — stored at org level, used in report headers/exports
//   • Banner / colours    — org brand colours applied to section headers etc.
//   • Other graphics      — any additional assets (e.g. footer imagery)
//
// The cover image will be picked from the Documentation Page > Documents & Media
// section rather than uploaded here directly.
//
// Props:
//   orgId   — number | null
//   orgName — string | null

import { withTranslation, Trans } from 'react-i18next';

function GraphicsTab({ t, orgId, orgName }) {
  if (!orgId) {
    return (
      <div className="pref pref--empty">
        <p>{t('report.builder.select_org_to_manage_report_graphics')}</p>
      </div>
    );
  }

  return (
    <div className="pref">
      <div className="pref__header">
        <h2 className="pref__org-name">
          {orgName || `${t('common.organisation')} ${orgId}`}
        </h2>
        <p className="pref__org-sub">
          {t('report.builder.report_graphics_and_branding')}
        </p>
      </div>

      {/* ── Cover image ──────────────────────────────────────────────────────── */}
      <div className="pref__section">
        <div className="pref__section-title">
          {t('report.builder.cover_image')}
        </div>
        <div className="pref__section-body pref__placeholder">
          <p>
            <Trans i18nKey="report.builder.cover_image_selected_from" />
          </p>
          <p className="pref__note">
            {t('report.builder.image_picker_in_next_phase')}
          </p>
        </div>
      </div>

      {/* ── Organisation logo ────────────────────────────────────────────────── */}
      <div className="pref__section">
        <div className="pref__section-title">
          {t('report.builder.org_logo')}
        </div>
        <div className="pref__section-body pref__placeholder">
          <p>{t('report.builder.logo_help')}</p>
          <p className="pref__note">
            {t('report.builder.upload_in_next_phase')}
          </p>
        </div>
      </div>

      {/* ── Brand colours / banner ───────────────────────────────────────────── */}
      <div className="pref__section">
        <div className="pref__section-title">
          {t('report.builder.brand_colors_and_banner')}
        </div>
        <div className="pref__section-body pref__placeholder">
          <p>{t('report.builder.primary_brand_colors')}</p>
          <p className="pref__note">
            {t('report.builder.color_picker_in_next_phase')}
          </p>
        </div>
      </div>

      {/* ── Other graphics ───────────────────────────────────────────────────── */}
      <div className="pref__section">
        <div className="pref__section-title">
          {t('report.builder.other_graphics')}
        </div>
        <div className="pref__section-body pref__placeholder">
          <p>{t('report.builder.additional_assets')}</p>
          <p className="pref__note">{t('common.to_be_designed')}</p>
        </div>
      </div>
    </div>
  );
}

GraphicsTab = withTranslation()(GraphicsTab);

export default GraphicsTab;
